module.exports = __webpack_public_path__ + "media/fonts/ppneuemachina-ultrabold-webfont-25605bb3f7b68f34c65eff997c1906f1.woff";